const TokenService = {
    updateAccessToken: (token) => {
      localStorage.setItem("access_token", token);
    },
    getAccessToken: () => {
      return localStorage.getItem("access_token");
    },
    setAccessToken: (token) => {
      localStorage.setItem("access_token", token);
    },
    removeAccessToken: () => {
      localStorage.removeItem("access_token");
    }
  }
  
  export default TokenService;